import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/base.scss';
import './assets/style/element-ui.scss';
import './assets/style/theme.scss';
import './assets/style/px2rem.scss';
import './assets/style/animation.scss';
import store from './store/index';
import met from './utils/met.js';
import moment from 'moment';
import VeCharts from 've-charts'
import ElementUI from 'element-ui';


import {
    Message,
    Loading,
} from 'element-ui';

const elementComponents = [
    Option,
];

Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.use(met);
Vue.use(Loading);
Vue.prototype.$moment = moment;
Vue.prototype.$message = Message;
Vue.use(VeCharts);

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');
